import styles from "./SelectPerformance.module.css";
import * as Menu from "components/MenuPanel/MenuPanel";

import { Badge } from "components/Badge/Badge";
import { Identity } from "components/Identity";
import { IconStackOne } from "components/Icons/IconStackOne";
import { IconStackTwo } from "components/Icons/IconStackTwo";
import { IconStackThree } from "components/Icons/IconStackThree";
import { IconCoins } from "components/Icons/IconCoins";
import {
  ExecutionTiersData,
  SupportedPublicPerformanceTierKey,
} from "./useGetPerformanceTiers";

import type { ActiveContext } from "shared/ContextSwitcher/store";

interface Props {
  activeContext: Pick<ActiveContext, "type" | "handle" | "profile_image_url">;
  performanceTiers: ExecutionTiersData[];
  performance: SupportedPublicPerformanceTierKey;
  setPerformance: (performance: SupportedPublicPerformanceTierKey) => void;
  close: () => void;
}

export function MenuSelectPerformance(props: Props) {
  const { performance, setPerformance, performanceTiers } = props;
  return (
    <Menu.Panel className={styles.menu}>
      <Menu.Section
        title={
          <>
            <span className={styles.title}>Query engine size</span>
            <Identity
              size="S"
              color="inherit"
              flip
              owner={props.activeContext}
            />
          </>
        }
      >
        {performanceTiers.map((perfTier) => (
          <Menu.ItemButton
            key={perfTier.publicPerformanceTierKey}
            active={performance === perfTier.publicPerformanceTierKey}
            onClick={() => {
              setPerformance(perfTier.publicPerformanceTierKey);
              props.close();
            }}
            description={perfTier.description}
            hasIconBeforeText={true}
          >
            <IconPerformance performance={perfTier.publicPerformanceTierKey} />
            <span>{perfTier.displayName}</span>
            <Badge size="M" color="brand-blue" variant="filled">
              {perfTier.credits}
              <IconCoins />
            </Badge>
          </Menu.ItemButton>
        ))}
      </Menu.Section>
      <Menu.Section>
        <Menu.ItemLink
          href="/docs/query/query-executions/#query-engine-size"
          target="_blank"
          color="blue"
        >
          Learn more
        </Menu.ItemLink>
      </Menu.Section>
    </Menu.Panel>
  );
}

export function IconPerformance(props: {
  performance: SupportedPublicPerformanceTierKey;
}) {
  switch (props.performance) {
    case "free":
      return <IconStackOne />;
    case "medium":
      return <IconStackTwo />;
    case "large":
      return <IconStackThree />;
  }
}
